var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { updateQuerySelected } from 'src/redux/cases/helpers/filtersHelpers';
import { E_OPERATOR, E_PRESET, E_SORT_ORDER, E_TYPE_FILTER, } from 'src/redux/cases/types/filtersTypes';
import { FIELD_NAMES, isFilterChoiceObject, isFilterChoiceString, } from 'src/services/core/types/moConfigTypes';
import { deepMergeObj, getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var parseApiPingResponse = function (response, name) {
    return { status: response.status, isValid: response.status === 200, url: response.url, name: name };
};
var getRightOperator = function (type) {
    if (!type) {
        return null;
    }
    switch (type) {
        case E_TYPE_FILTER.TEXT: {
            return E_OPERATOR.CONTAINS;
        }
        case E_TYPE_FILTER.SELECT_LIST: {
            return E_OPERATOR.EQUALS;
        }
        case E_TYPE_FILTER.DATE_RANGE: {
            return E_OPERATOR.BETWEEN;
        }
        default: {
            return null;
        }
    }
};
export var parseDefaultCasesFilters = function (i18n, defaultFilter, allQuery) {
    var _a;
    // can we have multiple filters ?
    var defaultFilterFromFiltersCollection = (defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.filter)
        ? allQuery.find(function (filt) { return filt.fieldName && filt.fieldName.includes(defaultFilter.filter.fieldName); })
        : null;
    var choiceInAllQuery = defaultFilterFromFiltersCollection
        ? defaultFilterFromFiltersCollection.choices.find(function (choice) { return choice.id === defaultFilter.filter.value[0]; })
        : null;
    var allProduct = { label: getPropsByKeyPath(i18n.keyValueMap, 'filter.product.label.*'), value: '*' };
    var productFilterIndex = allQuery.findIndex(function (filt) { return filt.fieldName && filt.fieldName.includes(FIELD_NAMES.PRODUCTS); });
    var defaultQueries = defaultFilterFromFiltersCollection
        ? updateQuerySelected(allQuery, [], defaultFilterFromFiltersCollection, [choiceInAllQuery])
        : [];
    var productFilter = productFilterIndex !== -1 ? allQuery[productFilterIndex] : null;
    var queryForProduct = (productFilter === null || productFilter === void 0 ? void 0 : productFilter.showByDefault)
        ? {
            id: productFilterIndex.toString(),
            fieldName: FIELD_NAMES.PRODUCTS,
            operator: E_OPERATOR.EQUALS,
            values: ((_a = defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.products) === null || _a === void 0 ? void 0 : _a.map(function (defaultProduct) {
                var productFounded = productFilter ? productFilter.choices.find(function (prod) { return prod.value === defaultProduct; }) : null;
                if (defaultProduct === '*') {
                    return allProduct;
                }
                var labelProductFounded = getPropsByKeyPath(i18n.keyValueMap, "filter.product.label.".concat(productFounded === null || productFounded === void 0 ? void 0 : productFounded.value)); // API can send keyPath ?
                return { label: labelProductFounded, value: productFounded === null || productFounded === void 0 ? void 0 : productFounded.value };
            })) || [allProduct],
        }
        : null;
    var defaultQueriesWithProduct = __spreadArray([], defaultQueries, true);
    if (queryForProduct) {
        defaultQueriesWithProduct.push(queryForProduct);
    }
    return {
        query: defaultQueriesWithProduct,
        count: defaultFilter.count,
        products: defaultFilter.products,
        offset: 0,
        sortFields: defaultFilter.sort.map(function (crit) { return (__assign(__assign({}, crit), { field: crit.field.substring(crit.field.indexOf('.') + 1) })); }),
    };
};
// When we change locale we need to update query with label associated to new locale
export var checkLocaleQueryInUrl = function (query, allQuery) {
    var queriesLocaleChecked = query.query.map(function (queryItem) {
        var queryInUrl = allQuery.find(function (query) { return query.id === queryItem.id; });
        return __assign(__assign({}, queryItem), { values: queryItem.values.map(function (queryItemValue) {
                var _a;
                var queryInUrlValue = (_a = queryInUrl === null || queryInUrl === void 0 ? void 0 : queryInUrl.choices) === null || _a === void 0 ? void 0 : _a.find(function (query) { return String(query.value) === String(queryItemValue.value); });
                return queryInUrlValue ? __assign(__assign({}, queryItemValue), { label: queryInUrlValue.label }) : queryItemValue;
            }) });
    });
    return __assign(__assign({}, query), { query: queriesLocaleChecked });
};
export var parseCasesDefaultColumn = function (column, i18n) {
    return column.map(function (col) {
        var keyMapForValue = col.sources ? col.sources : [{ source: col.source }];
        return {
            type: col.type,
            label: getPropsByKeyPath(i18n.keyValueMap, col.label),
            display: col.display,
            sortable: col.sortable,
            style: col.elStyle,
            delimiter: col.delimiter,
            keyMapForValue: keyMapForValue,
        };
    });
};
var parseFilterChoices = function (filterConf, choices, i18n, dynamicDataMap) {
    if (choices === void 0) { choices = []; }
    var type = filterConf.type;
    switch (type) {
        case E_TYPE_FILTER.SELECT_LIST: {
            return parseFilterChoicesForSelectList(filterConf, choices, i18n, dynamicDataMap);
        }
        case E_TYPE_FILTER.DATE_RANGE: {
            return parseFilterChoicesForDateRange(filterConf, choices, i18n);
        }
        case E_TYPE_FILTER.TEXT: {
            return [];
        }
    }
};
var parseFilterChoicesForSelectList = function (filterConf, choices, i18n, dynamicDataMap) {
    return choices.map(function (item) {
        if (typeof item === 'number' || typeof item === 'string') {
            return {
                id: String(item),
                label: String(item),
                value: String(item),
            };
        }
        if (!isFilterChoiceObject(item)) {
            return;
        }
        var label = getPropsByKeyPath(i18n.keyValueMap, item.name) || item.name;
        if (item.choices || item.choicesRef || item.choicesRefs) {
            // sub-choices
            var subChoices = buildFilterChoices(filterConf, item.choices, item.choicesRef, item.choicesRefs, item.choicesSort, i18n, dynamicDataMap);
            return {
                fieldNames: item.targetFields || (item.targetField && [item.targetField]),
                label: label,
                value: subChoices,
            };
        }
        var valueIsInI18n = getPropsByKeyPath(i18n.keyValueMap, item.id);
        return {
            id: item.id,
            label: label,
            value: !!item.query ? item.query : valueIsInI18n ? valueIsInI18n : item.id,
        };
    });
};
var parseFilterChoicesForDateRange = function (filterConf, choices, i18n) {
    return choices.map(function (item) {
        var _a, _b;
        if (!isFilterChoiceString(item)) {
            return;
        }
        //const valueIsInI18n = getPropsByKeyPath(i18n.keyValueMap, item.id) method mapping value
        return {
            id: item,
            label: getPropsByKeyPath((_b = (_a = i18n === null || i18n === void 0 ? void 0 : i18n.components) === null || _a === void 0 ? void 0 : _a.dateTimeRangeSelectInput) === null || _b === void 0 ? void 0 : _b.customLabels, item),
            value: {
                value: 'now-1h',
                value2: 'now',
            },
        };
    });
};
var transformChoicesUsingPreset = function (preset, i18n, choices) {
    switch (preset) {
        case E_PRESET.PRODUCT_CODE: {
            return choices
                ? choices.map(function (product) {
                    var labelForProduct = getPropsByKeyPath(i18n.keyValueMap, "filter.product.label.".concat(product.value)); // API can send keyPath ?
                    return { id: product.id, label: labelForProduct || product.label, value: product.value };
                })
                : [];
        }
        default: {
            return choices;
        }
    }
};
export var buildFilterChoicesFromFilterConf = function (filterConf, i18n, dynamicDataMap) {
    var choices = filterConf.choices, choicesRef = filterConf.choicesRef, choicesRefs = filterConf.choicesRefs, choicesSort = filterConf.choicesSort;
    return buildFilterChoices(filterConf, choices, choicesRef, choicesRefs, choicesSort, i18n, dynamicDataMap);
};
var buildFilterChoices = function (filterConf, choices, choicesRef, choicesRefs, choicesSort, i18n, dynamicDataMap) {
    var preset = filterConf.preset;
    // Add simple choices
    var filterPrepared = parseFilterChoices(filterConf, choices, i18n, dynamicDataMap);
    var mergedChoicesByLabel = {}; // to avoid duplicates
    filterPrepared.forEach(function (choiceItem) {
        mergedChoicesByLabel[choiceItem.label] = choiceItem;
    });
    // Compute choices refs
    //
    // We can have multiple choices refs, for cases where the choice items are
    // coming from several REST endpoint calls
    //
    // Also, the code must handle the 2 following fields:
    //  - choicesRef
    //  - choicesRefs[]
    var allChoicesRefs = __spreadArray(__spreadArray([], ([choicesRef] || []), true), (choicesRefs || []), true);
    // Add choices from choices refs
    allChoicesRefs.forEach(function (choicesRefItem) {
        var dynamicData = dynamicDataMap[choicesRefItem] || [];
        dynamicData.forEach(function (choiceItem) {
            var stringValue = typeof choiceItem.value === 'object' ? choiceItem.value : String(choiceItem.value);
            var stringLabel = String(choiceItem.label);
            mergedChoicesByLabel[stringLabel] = __assign(__assign({}, choiceItem), { id: choiceItem.id || stringLabel, label: stringLabel, value: stringValue });
        });
    });
    // Convert mergedChoices back to array
    var mergedChoices = [];
    for (var label in mergedChoicesByLabel) {
        var choiceItem = mergedChoicesByLabel[label];
        mergedChoices.push(choiceItem);
    }
    // Choices sort
    var choicesSortOrder = choicesSort === null || choicesSort === void 0 ? void 0 : choicesSort.order;
    if (choicesSortOrder) {
        sortChoices(mergedChoices, choicesSortOrder);
    }
    // Finalize using preset
    return preset ? transformChoicesUsingPreset(preset, i18n, mergedChoices) : mergedChoices;
};
export var sortChoices = function (array, order) {
    var isAscending = order !== E_SORT_ORDER.DESC;
    sortArray(array, isAscending, function (choiceItem) { return choiceItem.label; });
};
var sortArray = function (array, isAscending, attributeSelector) {
    array.sort(function (a, b) {
        var sortAttrA = attributeSelector(a);
        var sortAttrB = attributeSelector(b);
        if (sortAttrA < sortAttrB) {
            return isAscending ? -1 : 1;
        }
        if (sortAttrA > sortAttrB) {
            return isAscending ? 1 : -1;
        }
        return 0;
    });
};
var buildTargetFields = function (filterConf) {
    var keyToMap = filterConf.keyToMap, targetField = filterConf.targetField, targetFields = filterConf.targetFields, field = filterConf.field, choicesRef = filterConf.choicesRef, choicesRefs = filterConf.choicesRefs;
    if (targetFields) {
        return targetFields;
    }
    if (targetField) {
        return [targetField];
    }
    return (keyToMap && [keyToMap]) || (field && [field]) || choicesRefs || (choicesRef && [choicesRef]) || [];
};
export var parseFilters = function (filters, filterPresets, i18n, dynamicDataMap) {
    return filters
        .map(function (filter) {
        var preset = filter.preset;
        if (!preset) {
            return filter;
        }
        var filterPreset = filterPresets[preset] || {};
        return deepMergeObj(filterPreset, filter);
    })
        .map(function (flt, index) {
        var type = flt.type, preset = flt.preset, showByDefault = flt.showByDefault, sticky = flt.sticky, restFilter = __rest(flt, ["type", "preset", "showByDefault", "sticky"]);
        if (preset === E_PRESET.FULL_SEARCH) {
            return {
                id: index.toString(),
                type: E_TYPE_FILTER.SEARCH,
                fieldName: FIELD_NAMES.SEARCH,
                label: getPropsByKeyPath(i18n.components, 'caseFilter.fullSearchLabel'),
                showByDefault: showByDefault,
                sticky: sticky,
            };
        }
        var choices = buildFilterChoicesFromFilterConf(flt, i18n, dynamicDataMap);
        var allTargetFields = buildTargetFields(flt);
        return __assign(__assign({}, restFilter), { id: index.toString(), // because fieldName is not unique
            type: type, sticky: sticky, showByDefault: showByDefault, choices: choices, fieldName: allTargetFields[0], fieldNames: allTargetFields, operator: getRightOperator(type), label: getPropsByKeyPath(i18n.keyValueMap, flt.label) || flt.label });
    });
};
export var parseDefaultUsersFilters = function (i18n, defaultFilter) {
    return {
        count: defaultFilter.count,
        resultsPerPage: defaultFilter.count,
        offset: 0,
        page: 0,
        search: '',
    };
};
